import { lazyLoad } from 'site-modules/shared/components/lazy-load/lazy-load';

export const ExperimentsPanelContentAsync = lazyLoad({
  loader: () => import(/* webpackChunkName: "experiments-panel-content" */ './experiments-panel-content'),
  componentName: 'ExperimentsPanelContent',
});
